import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosHttp from 'services/axiosHttp';
import { message } from 'antd';

// CREATE ACTION
export const updateQrType = createAsyncThunk(
  'qrTypeUpdate/updateQrType',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.patch('lcqr/updateqrtype', { qr_id: id, qr_name: data.qr_name });
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const QrTypeUpdateSlice = createSlice({
  name: 'QrTypeUpdateSlice',
  initialState: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
  },

  reducers: {
    resetUpdateState: (state) => {
      state.isLoading = false;
      state.error = false;
      state.data = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(updateQrType.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    });

    builder.addCase(updateQrType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.data = action.payload;
    });

    builder.addCase(updateQrType.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export const { resetUpdateState } = QrTypeUpdateSlice.actions;
export default QrTypeUpdateSlice.reducer;
